import { FC } from "react";
import { ArrowRightGradientSVG, GatewayFullLogoSVG } from "../../assets";
import "./Footer.scss";
import { SocialLinks } from "./SocialLinks/SocialLinks";

export const Footer: FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={`footer ${className || ""}`}>
      <div className="footer__outer-container">
        <div className="footer__inner-container">
          <div className="footer__left-container">
            <GatewayFullLogoSVG width={132} />
            <span className="footer__left-container-copyright">
              © 2024 Gateway. All Rights Reserved.
            </span>
          </div>
          <div className="footer__right-item">
            <div className="footer__right-container">
              <div className="footer__right-container-links">
                {/* <a
                  href="https://blog.mygateway.io"
                  rel="noreferrer"
                  target="_blank"
                >
                  Blog
                  <ArrowRightGradientSVG />
                </a> */}
                <a
                  href="https://mygateway.io/privacy_policy.pdf"
                  rel="noreferrer"
                  target="_blank"
                >
                  Privacy Policy
                  <ArrowRightGradientSVG />
                </a>
                <a
                  href="https://mygateway.io/terms_of_use.pdf"
                  rel="noreferrer"
                  target="_blank"
                >
                  Terms of use
                  <ArrowRightGradientSVG />
                </a>
                <a
                  href="https://drive.google.com/drive/folders/1Awbwoawz61prnmy-iZtnD4AGFMFfYTat?usp=sharing"
                  rel="noreferrer"
                  target="_blank"
                >
                  Brandbook
                  <ArrowRightGradientSVG />
                </a>
              </div>
              <SocialLinks
                discordLink="https://discord.gg/BRF2PEetea"
                twitterLink="https://x.com/gateway_web3"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
